import { useContext } from 'react';
import { StoreContext } from "@roc/feature-app-core"
import { ContactInformationStore } from "../stores/contactInformationStore";

export const useContactInformationStore = () => useContext<{
  contactInformationStore: ContactInformationStore
}>(StoreContext);